<template>
    <div>
        <div class="form-single">
            <div class="title">申请服务单号:</div>
            <div class="content">{{servcReqVoucher.no}}</div>
        </div>
        <div class="form-single">
            <div class="title">零售商名称:</div>
            <div class="content">{{servcReqVoucher.buyerComName}}</div>
        </div>
        <div class="form-single">
            <div class="title">联系电话:</div>
            <div class="content">{{servcReqVoucher.buyerShopContactTel}}</div>
        </div>

        <div class="graphic-info">
            <div class="graphic-item">
                <div class="image-info">
                    <img :src="servcReqVoucher.servcBrowseUrl"/>
                </div>
                <div class="text-info" style="padding-left: 146px;">
                    <p class="name font14">
                        <span class="mr10">服务号</span>
                        <span class="value font-gray3">{{servcReqVoucher.svcNo || '无'}}</span>
                    </p>
                    <p class="model">
                        <span class="mr10">机构地址</span>
                        <span class="value font-gray3">{{servcReqVoucher.buyerShopAddr}}</span>
                    </p>
                    <p class="num">
                        <span class="mr10">备注</span>
                        <span class="value font-red">{{servcReqVoucher.requestDesc || '无'}}</span>
                    </p>
                </div>
            </div>
        </div>
        <el-form :model="servcReqVoucher" class="demo-ruleForm">
            <div class="form-single">
                <div class="title required">请选择指派方:</div>
                <div class="content">
                    <el-form-item prop="servicerComName">
                        <swb-org-tree :isShowIcon=false  :enableSearch=true :isRadio=true ref="swb_org_tree"></swb-org-tree>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import servcDisptApi from '../../api/servcDispt'

    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);

    export default {
        name: 'swb-servc-req-appoint-store',
        desc: '指派门店',
        props: ['servcReqVoucherId'],
        data: function () {
            return {
                servcReqVoucher: {},
                radio: '1',
                enableSearch: null,
                buyerRegionId: null,
                selectFlag: "default",
            }
        },
        created: function () {
            let self = this;
            self.enableSearch = true;
            self.getServcReqVoucher();
        },
        methods: {
            getServcReqVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.servcReqVoucherId;
                let loading = MsgBox.loading();
                servcDisptApi.getServcReqVoucher(postData, function (result) {
                    if(result.type == "info") {
                        self.servcReqVoucher = result.data;
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                let resultTree = self.$refs.swb_org_tree.getDlgResult() || {};
                if(resultTree.type == 'info') {
                    result.type = 'info';
                    result.data = resultTree.data;
                }
                return result;
            }
        }
    }
</script>
<style>
    .form-single .tree-structure-collapse + .el-input {
        margin-top: 0;
    }

    .form-single .el-input {
        margin-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/compo/servcReq/ServcReqAppointStore.vue